import React from 'react'
import { Button } from 'react-bootstrap'

export default function SearchButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button type='button' size='sm' className='filter_btn' onClick={onClick}>{button_name}</Button>
        </>
    )
}